module.exports = __webpack_public_path__ + "static/img/swiper1.a93b9b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/swiper1.jpg
// module id = xNeV
// module chunks = 1